import { render, staticRenderFns } from "./PersonalTab.vue?vue&type=template&id=db67e228&"
import script from "./PersonalTab.vue?vue&type=script&lang=js&"
export * from "./PersonalTab.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports